import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[flow-host]',
})
export class FlowDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/flow/flow.directive.ts